import React from 'react';
import PropTypes from 'prop-types';
import cname from './style.module.scss';
import {VolumeModal} from './VolumeModal';
import {PipetteImage} from './MicroPipetteImages';
import {MicroPipetteTooltip} from './MicroPipetteTooltip';
import {
  P2,
  P20,
  TUBE,
  P200,
  P1000,
  TRASH,
  GLASS_TUBE,
  PLUNGER_TOOLTIP_TYPE,
} from './MicroPipette.constants';

import i18next from './locale/i18next';
import {I18nextProvider} from 'react-i18next';

const i18n = i18next;

const changeLang = (lang) => {
  i18n.changeLanguage(lang);
};
/**
 * MicroPipette:
 *  - Lab Equipment used to transfer solution between different apparatus
 */
export class MicroPipette extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
    };
    props.lang && changeLang(props.lang)
  }


  setShowVolumeModal = (value) => () => {
    this.props.toggleShowVolumeModal(value);
  };

  toggleTooltip = (value) => () => {
    this.setState({hover: value});
  };

  setOnRemoveTip = () => {
    if (this.props.contactElement.type === TRASH && this.props.hasTip)
      return this.props.removeTip;
    else return undefined;
  };

  render() {
    return (
      <>
      <I18nextProvider i18n={i18n}>
        <div
          className={cname.wrap}
          //onMouseEnter={this.toggleTooltip(true)}
          //onMouseLeave={this.toggleTooltip(false)}
        >
          <MicroPipetteTooltip
            show={this.state.hover}
            label={this.props.type}
            onMix={this.props.onMix}
            volume={this.props.volume}
            onRemoveTip={this.setOnRemoveTip()}
            plungerTooltip={this.props.plungerTooltip}
            contactElement={this.props.contactElement}
            onFirstStopper={this.props.onFirstStopper}
            onSecondStopper={this.props.onSecondStopper}
            openVolumeModal={this.setShowVolumeModal(true)}
            togglePlungerTooltip={this.props.togglePlungerTooltip}
          />
          <div className={cname.pipette}>
            <PipetteImage
              className={cname.icon}
              type={this.props.type}
              hasTip={this.props.hasTip}
              solution={this.props.solution}
            />
          </div>
        </div>
        <VolumeModal
          modalOpen={this.props.showVolumeModal}
          type={this.props.type}
          hasTip={this.props.hasTip}
          volume={this.props.volume}
          setVolume={this.props.setVolume}
          onClose={this.setShowVolumeModal(false)}
          notebookExpanded={this.props.notebookExpanded}
          lang={this.props.lang}
        />
        </I18nextProvider>
      </>
    );
  }
}

MicroPipette.propTypes = {
  /**
   * Type of MicroPipette [ P2, P20, P200, P1000]
   */
  type: PropTypes.oneOf([P2, P20, P200, P1000]).isRequired,
  /**
   * Boolean to set if Pipette has tip attached
   */
  hasTip: PropTypes.bool,
  /**
   * Hex Color value of solution in MicopipetteTip
   */
  solution: PropTypes.string,
  /**
   * Current set value for volume
   */
  volume: PropTypes.number,
  /**
   * Callback to set current Volume
   */
  setVolume: PropTypes.func,
  /**
   * Boolean set to display AdjustVolume Modal
   */
  showVolumeModal: PropTypes.bool,
  /**
   * Function to toggle Show Volume Modal
   */
  toggleShowVolumeModal: PropTypes.func,
  /**
   * Apparatus currently interacting with MicroPipette
   */
  contactElement: PropTypes.shape({
    /**
     * Type of Apparatus currently in contact with MicroPipette
     */
    type: PropTypes.oneOf(['', TRASH, GLASS_TUBE, TUBE]),
    /**
     * UniqueId of Apparatus currently in contact with MicroPipette
     */
    id: PropTypes.number,
  }),
  /**
   * Callback to remove Micropipette Tip
   */
  removeTip: PropTypes.func,
  /**
   *  Plunget Tooltip set as current
   */
  plungerTooltip: PropTypes.oneOf([
    PLUNGER_TOOLTIP_TYPE.MIXER,
    PLUNGER_TOOLTIP_TYPE.STOPPER,
  ]),
  /**
   * Funtion to toggle currentPlungerTooltip
   */
  togglePlungerTooltip: PropTypes.func,
  /**
   * Callback function for First Stopper Press
   */
  onFirstStopper: PropTypes.func,
  /**
   * Callback function for Second Stopper Press
   */
  onSecondStopper: PropTypes.func,
  /**
   * Callback function for Mixer Operation
   */
  onMix: PropTypes.func,
};

MicroPipette.defaultProps = {
  tip: '',
  type: P2,
};
